var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("new-edit-page", {
    attrs: {
      "page-title": _vm.pageTitle(_vm.actionType, "ClientRole"),
      "submit-button-label": _vm.submitButtonLabel(_vm.actionType),
      "submit-button-disabled": _vm.submitButtonDisabled,
      "is-loading": _vm.loading
    },
    on: { submit: _vm.submit },
    scopedSlots: _vm._u([
      {
        key: "leftSideContent",
        fn: function() {
          return [
            _c(
              "v-layout",
              { attrs: { row: "", "justify-space-between": "", wrap: "" } },
              [
                _c("div", { staticClass: "input-field-container md-large" }, [
                  _c(
                    "label",
                    { staticClass: "required", attrs: { for: "label" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tc("Label", 1)) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "input-field",
                    class: { fieldErrorInput: _vm.validation.badLabel },
                    attrs: { id: "label" },
                    domProps: { value: _vm.role.label },
                    on: {
                      input: function($event) {
                        return _vm.updateField("label", $event.target.value)
                      },
                      change: function($event) {
                        return _vm.validateString("badLabel", _vm.role.label)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.validation.badLabel
                    ? _c("div", { staticClass: "field-error-div" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("ValidLabel")) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-field-container large" }, [
                  _c("label", { attrs: { for: "description" } }, [
                    _vm._v(_vm._s(_vm.$t("Description")))
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    staticClass: "input-field",
                    attrs: { id: "description" },
                    domProps: { value: _vm.role.description },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "description",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "input-field-container radio-container medium"
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "required", attrs: { for: "active" } },
                      [_vm._v(_vm._s(_vm.$t("Status")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: {
                          id: "active",
                          value: _vm.role.active,
                          row: true
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateField("active", $event)
                          }
                        }
                      },
                      [
                        _c("v-radio", {
                          attrs: {
                            label: _vm.$t("Active"),
                            value: true,
                            ripple: false,
                            color: "#4fa2b7"
                          }
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          attrs: {
                            label: _vm.$t("Inactive"),
                            value: false,
                            ripple: false,
                            color: "#4fa2b7"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-field-container medium" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "input-field-container",
                    style: { width: _vm.fieldWidth }
                  },
                  [
                    _c("v-switch", {
                      attrs: {
                        color: "accent",
                        "input-value": _vm.role.visible,
                        label: _vm.role.visible
                          ? _vm.$t("Visible")
                          : _vm.$t("NotVisible")
                      },
                      on: {
                        change: function($event) {
                          return _vm.updateField("visible", $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "input-field-container",
                    style: { width: _vm.fieldWidth }
                  },
                  [
                    _c("v-switch", {
                      attrs: {
                        color: "accent",
                        "input-value": _vm.role.blocked,
                        label: _vm.role.blocked
                          ? _vm.$t("Blocked")
                          : _vm.$t("Unblocked")
                      },
                      on: {
                        change: function($event) {
                          return _vm.updateField("blocked", $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.actionType === "create"
                  ? _c(
                      "div",
                      { staticClass: "input-field-container large" },
                      [
                        _c("label", [
                          _vm._v(" " + _vm._s(_vm.$t("BaseRole")) + " ")
                        ]),
                        _vm._v(" "),
                        _c("treeselect", {
                          attrs: {
                            value: _vm.baseRoleId,
                            options: _vm.roleOptions,
                            "load-options": _vm.loadRoleOptions
                          },
                          on: {
                            input: function($event) {
                              _vm.baseRoleId = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        },
        proxy: true
      },
      {
        key: "rightSideHeader",
        fn: function() {
          return [
            _c("management-tabs-and-search", {
              attrs: {
                tabs: _vm.tabs,
                "open-tab": _vm.openTab,
                search: _vm.search
              },
              on: {
                "update-open-tab": function($event) {
                  _vm.openTab = $event
                },
                "update-search": function($event) {
                  _vm.search[$event.tab] = $event.value
                }
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "rightSideContent",
        fn: function() {
          return [
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.openTab,
                  callback: function($$v) {
                    _vm.openTab = $$v
                  },
                  expression: "openTab"
                }
              },
              [
                _c(
                  "v-tab-item",
                  { attrs: { value: "permissions" } },
                  [
                    _c("permissions-section", {
                      attrs: {
                        "account-type": "clientRole",
                        previousRolesAndPermissions:
                          _vm.previousRolesAndPermissions,
                        "has-permission-to-edit": true,
                        type: _vm.actionType
                      },
                      on: {
                        selectedPermissions: function($event) {
                          return _vm.updateField("permissions", $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { attrs: { value: "webUsers" } },
                  [
                    _c("associated-users", {
                      attrs: {
                        "action-type": _vm.actionType,
                        "user-type": "web",
                        from: "role",
                        "associated-users": _vm.role.usersWebAssociates,
                        "has-permission-to-edit": _vm.hasUsersPermission,
                        "search-from-parent": _vm.search.webUsers
                      },
                      on: {
                        "associate-users": function($event) {
                          return _vm.updateField("usersWebAssociates", $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { attrs: { value: "mobileUsers" } },
                  [
                    _c("associated-users", {
                      attrs: {
                        "action-type": _vm.actionType,
                        "user-type": "mobile",
                        from: "role",
                        "associated-users": _vm.role.usersMobileAssociates,
                        "has-permission-to-edit": _vm.hasUsersPermission,
                        "search-from-parent": _vm.search.mobileUsers
                      },
                      on: {
                        "associate-users": function($event) {
                          return _vm.updateField(
                            "usersMobileAssociates",
                            $event
                          )
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { attrs: { value: "companies" } },
                  [
                    _c("associated-companies", {
                      attrs: {
                        from: "role",
                        "action-type": _vm.actionType,
                        "associated-companies": _vm.role.companies,
                        "has-permission-to-edit": _vm.hasCompaniesPermission,
                        "search-from-parent": _vm.search.companies
                      },
                      on: {
                        "associate-companies": function($event) {
                          return _vm.updateField("companies", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98c592c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98c592c4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/ClientRoles/ClientRoleForm.vue
// module id = null
// module chunks = 